import { render, staticRenderFns } from "./AgeGroupsCombo.vue?vue&type=template&id=79cc8a47&scoped=true"
import script from "./AgeGroupsCombo.vue?vue&type=script&lang=js"
export * from "./AgeGroupsCombo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cc8a47",
  null
  
)

export default component.exports